import React from "react";
import { withNamespaces } from 'react-i18next';

const AcVisto = ({t}) => {
  return (
    <>
      <div className="accordion" id="accordionExample_vistos">
        {/* 1 */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="vistos_heading1">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#vistos_collapse1"
              aria-expanded="true"
              aria-controls="vistos_collapse1"
            >
              {t('moduleFaqs:S2.A.A1.T')}
            </button>
          </h2>
          <div
            id="vistos_collapse1"
            className="accordion-collapse collapse"
            aria-labelledby="vistos_heading1"
            data-bs-parent="#accordionExample_vistos"
          >
            <div className="accordion-body">
              <div className="p_accordion">
                <ul>
                  <li className="p_accordion">
                    <p className="p_next">
                      <span  dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S1.A.A1.LI1') }}></span>
                      <a className='link' target='_blank' rel='noreferrer' href={t('moduleFaqs:S1.A.A1.Link.Link')} title={t('moduleFaqs:S1.A.A1.Link.Title')}>{t('moduleFaqs:S1.A.A1.Link.NameLink')}</a>
                    </p>
                    
                  </li>
                  <li className="p_accordion">
                    <p className="p_next">
                      <span dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S1.A.A1.LI2') }}></span>
                      <a className='link' target='_blank' rel='noreferrer' href={t('moduleFaqs:S1.A.A1.Link2.Link')} title={t('moduleFaqs:S1.A.A1.Link2.Title')}>{t('moduleFaqs:S1.A.A1.Link2.NameLink')}</a>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* 2 */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="vistos_heading2">
            <button
              className="accordion-button collapsed text-left"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#vistos_collapse2"
              aria-expanded="false"
              aria-controls="vistos_collapse2"
            >
              {t('moduleFaqs:S1.A.A2.T')}
            </button>
          </h2>
          <div
            id="vistos_collapse2"
            className="accordion-collapse collapse"
            aria-labelledby="vistos_heading2"
            data-bs-parent="#accordionExample_vistos"
          >
            <div className="accordion-body">
              <p className="p_accordion">
                <span  dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S1.A.A2.P1') }}></span>
                <a className='link' target='_blank' rel='noreferrer' href={t('moduleFaqs:S1.A.A2.Link.Link')} title={t('moduleFaqs:S1.A.A2.Link.Title')}>{t('moduleFaqs:S1.A.A2.Link.NameLink')}</a>
                <span  dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S1.A.A2.P2') }}></span>
              </p>
            </div>
          </div>
        </div>
        {/* 3*/}
        <div className="accordion-item">
          <h2 className="accordion-header" id="vistos_heading3">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#vistos_collapse3"
              aria-expanded="false"
              aria-controls="vistos_collapse3"
            >
              {t('moduleFaqs:S1.A.A3.T')}
            </button>
          </h2>
          <div
            id="vistos_collapse3"
            className="accordion-collapse collapse"
            aria-labelledby="vistos_heading3"
            data-bs-parent="#accordionExample_vistos"
          >
            <div className="accordion-body">
              <p className="p_accordion"
                dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S1.A.A3.P1') }}
              >
              </p>
              <ul>
                <li>
                  <p className="p_next">{t('moduleFaqs:S1.A.A3.UL.LI1')}</p>
                </li>
                <li>
                  <p className="p_next">{t('moduleFaqs:S1.A.A3.UL.LI2')}
                  </p>
                </li>
                <li>
                  <p className="p_next">{t('moduleFaqs:S1.A.A3.UL.LI3')}
                  </p>
                </li>
                <li>
                  <p className="p_next">{t('moduleFaqs:S1.A.A3.UL.LI4')}
                  </p>
                </li>
                <li>
                  <p className="p_next">{t('moduleFaqs:S1.A.A3.UL.LI5')}</p>
                </li>
                <li>
                  <p className="p_next">{t('moduleFaqs:S1.A.A3.UL.LI6')}
                  </p>
                </li>
                <li>
                  <p className="p_next">{t('moduleFaqs:S1.A.A3.UL.LI7')}</p>
                </li>
              </ul>
              <p className="p_next">
                <span dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S1.A.A3.P2') }}></span>
                <a className='link' target='_blank' rel='noreferrer' href={t('moduleFaqs:S1.A.A3.Link.Link')} title={t('moduleFaqs:S1.A.A3.Link.Title')}>{t('moduleFaqs:S1.A.A3.Link.NameLink')}</a>
                <span  dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S1.A.A3.P3') }}></span>
              </p>
            </div>
          </div>
        </div>
        {/* 4*/}
        <div className="accordion-item">
          <h2 className="accordion-header" id="vistos_heading4">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#vistos_collapse4"
              aria-expanded="false"
              aria-controls="vistos_collapse4"
            >
              {t('moduleFaqs:S1.A.A4.T')}
            </button>
          </h2>
          <div
            id="vistos_collapse4"
            className="accordion-collapse collapse"
            aria-labelledby="vistos_heading4"
            data-bs-parent="#accordionExample_vistos"
          >
            <div className="accordion-body">
              <p className="p_accordion" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S1.A.A4.P') }}></p>
            </div>
          </div>
        </div>
        {/* 5*/}
        <div className="accordion-item">
          <h2 className="accordion-header" id="vistos_heading5">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#vistos_collapse5"
              aria-expanded="false"
              aria-controls="vistos_collapse5"
            >
              {t('moduleFaqs:S1.A.A5.T')}
            </button>
          </h2>
          <div
            id="vistos_collapse5"
            className="accordion-collapse collapse"
            aria-labelledby="vistos_heading5"
            data-bs-parent="#accordionExample_vistos"
          >
            <div className="accordion-body">
              <p className="p_accordion">
                {t('moduleFaqs:S1.A.A5.P')}
              </p>
            </div>
          </div>
        </div>

        {/* 6 */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="vistos_heading6">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#vistos_collapse6"
              aria-expanded="false"
              aria-controls="vistos_collapse6"
            >
              {t('moduleFaqs:S1.A.A6.T')}
            </button>
          </h2>
          <div
            id="vistos_collapse6"
            className="accordion-collapse collapse"
            aria-labelledby="vistos_heading6"
            data-bs-parent="#accordionExample_vistos"
          >
            <div className="accordion-body">
              <p className="p_accordion" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S1.A.A6.P1') }}></p>
              <p className="p_accordion" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S1.A.A6.P2') }}></p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withNamespaces() (AcVisto);
